import { LevelFormat } from "docx";
import { GlyphType } from "types/Paragraph";

export const useConvertGlyphTypeToLevelFormat = (
  glyphType: GlyphType | undefined,
  glypthSymbol: string | undefined
) => {
  if (!glyphType || glypthSymbol) {
    return LevelFormat.BULLET;
  }

  switch (glyphType) {
    case "BULLET":
      return LevelFormat.BULLET;
    case "HOLLOW_BULLET":
      return LevelFormat.BULLET; // Adjust if there's a more suitable LevelFormat
    case "SQUARE_BULLET":
      return LevelFormat.BULLET; // Adjust if there's a more suitable LevelFormat
    case "DECIMAL":
      return LevelFormat.DECIMAL;
    case "UPPER_ROMAN":
      return LevelFormat.UPPER_ROMAN;
    case "ROMAN":
      return LevelFormat.LOWER_ROMAN;
    case "UPPER_ALPHA":
      return LevelFormat.UPPER_LETTER;
    case "ALPHA":
      return LevelFormat.LOWER_LETTER;
    case "SYMBOL":
      return LevelFormat.CUSTOM; // Adjust if there's a more suitable LevelFormat
    case "ALPHA":
      return LevelFormat.CARDINAL_TEXT; // Assuming "ALPHA" is a cardinal representation
    case "NUMBERED_DISC":
      return LevelFormat.DECIMAL; // Adjust if there's a more suitable LevelFormat
    case "NUMBERED_CIRCLE":
      return LevelFormat.DECIMAL; // Adjust if there's a more suitable LevelFormat
    case "NUMBERED_SQUARE":
      return LevelFormat.DECIMAL; // Adjust if there's a more suitable LevelFormat
    default:
      return LevelFormat.NONE; // Default value
  }
};
